import dynamic from "next/dynamic";
import CoursesBanner from "components/banners/CoursesBanner";
import PopularCourseSlider from "components/sliders/PopularCourseSlider";
import Categories from "components/category/Categories";
import CorporateLearningSolutionSlider from "components/sliders/CorporateLearningSolutionSlider";
import OurAccreditationsSlider from "components/sliders/OurAccreditationsSlider";
import OurBlogs from "components/blog/OurBlogs";
import TestimonialSlider from "components/sliders/TestimonialSlider";
const RequestForTrainingForm = dynamic(
  () => import("components/forms/RequestForTrainingForm"),
  { ssr: false }
);

//################################################################
import BackDropLoader from "components/BackDropLoader";
import Alert from "components/Alert";
import { initializeApollo, addApolloState } from "src/utils/apolloClient";
import { useQuery } from "@apollo/client";
import COURSES_PAGE_QUERY from "src/graphql/query/coursesPageQuery";
import COUNTRIES_QUERY from "src/graphql/query/countries";

import LoadComponent from "src/utils/loadComponents";
import mergeContents from "src/utils/mergeContents";
import Seo from "components/Seo";
import { GetStaticProps } from "next";
import AlternateLinks from "components/common/AlternateLnks";

//Components ####################################################
const Components = {
  coursesbanner: CoursesBanner,
  categories: Categories,
  popularcourseslider: PopularCourseSlider,
  corporatelearningsolutionslider: CorporateLearningSolutionSlider,
  ouraccreditationsslider: OurAccreditationsSlider,
  testimonialslider: TestimonialSlider,
  requestfortrainingform: RequestForTrainingForm,
  ourblogs: OurBlogs,
};

const CountryCourses = ({ country }) => {
  const { data, error, loading } = useQuery(COURSES_PAGE_QUERY, {
    variables: {
      slug: "courses",
      countryCode: country,
      pageType: "COUNTRY CATEGORIES",
      popularCourseType: "GENERIC COURSE",
      categoriesType: "GENERIC CATEGORY",
    },
  });
  if (error)
    return (
      <Alert open={Boolean(error)} type="error">
        {error.message}
      </Alert>
    );
  if (loading && !data) return <BackDropLoader open={loading && !data} />;

  const { title, meta_description, meta_keyword, pageContents } =
    data?.page_by_type_slug;
  const { popularCourses, page_categories_course_learner_counts, countries } =
    data;
  const dynamicData = {
    TestimonialSlider: {
      content: {
        testimonials: data.testimonials,
      },
    },
    PopularCourseSlider: {
      content: {
        heading: "Discover our Popular Courses",
        courses: popularCourses,
      },
    },
    Categories: {
      content: {
        heading:
          "Why Individuals and Enterprises <span>Choose Spoclearn?</span>",
        categories: page_categories_course_learner_counts,
      },
    },
  };

  const mergedData = mergeContents(pageContents, dynamicData);
  return (
    <>
      <Seo
        title={title}
        description={meta_description}
        keywords={meta_keyword}
      />
      <AlternateLinks countries={countries} />
      {mergedData?.map((item) => LoadComponent(item, Components))}
    </>
  );
};

export default CountryCourses;

//fetch all the country list before generating the ssg page for country home
export async function getStaticPaths() {
  const apolloClient = initializeApollo();
  const { data } = await apolloClient.query({
    query: COUNTRIES_QUERY,
  });
  // Get the paths we want to pre-render based on country
  const paths = data?.countries?.map((country) => ({
    params: { country: country.short_name },
  }));

  return { paths, fallback: false };
}

//Static Site generation
export const getStaticProps: GetStaticProps = async (context) => {
  const { country } = context.params;
  const apolloClient = initializeApollo();
  await apolloClient.query({
    query: COURSES_PAGE_QUERY,
    variables: {
      slug: "courses",
      countryCode: country,
      pageType: "COUNTRY CATEGORIES",
      popularCourseType: "GENERIC COURSE",
      categoriesType: "GENERIC CATEGORY",
    },
  });
  return addApolloState(apolloClient, {
    props: { country },
    revalidate: 1,
  });
};
